<template>
    <b-button :to="routerLink">
        <font-awesome-icon :icon="['fas', 'times']" />
        Abbrechen
    </b-button>
</template>

<script>
    export default {
        name: "CancelButton",
        props: {
            routerLink: String
        }
    }
</script>

<style scoped>

</style>